import { ExpenseBankingTransactionForExpenseDetailFragment } from 'generated/resources/graphql'

import { Expensable } from 'modules/expenses/types/Expensable'

type Transaction = ExpenseBankingTransactionForExpenseDetailFragment

export const transactionsFromExpensable = (expensable: Expensable) => {
  let transactions: Transaction[] = []

  if (expensable.expense?.dispute?.disputedTransaction) {
    transactions = [expensable.expense.dispute.disputedTransaction]
  }
  if (expensable.expense?.dispute?.refundTransaction) {
    transactions = [...transactions, expensable.expense.dispute.refundTransaction]
  }
  transactions = transactions.concat(expensable.expense?.cardPayment?.transactions ?? [])

  return transactions.reduce((unique: Transaction[], transaction) => {
    return unique.findIndex((item) => item.id === transaction.id) !== -1
      ? unique
      : [...unique, transaction]
  }, [])
}
